module.exports = __webpack_public_path__ + "img/pregeles-fempregeles.41e03f7d.jpg";